import Vue from 'vue';
import VueRouter from 'vue-router';
import App from './App.vue';
import Tool from './pages/Tool.vue';
import Login from './pages/Login.vue';
import moment from 'moment';
import httpClient from '../src/utils/httpClient';
import { tokenIsValid } from './utils/tokenUtils';
import ProgressHub from './utils/progressHub';
import BlockUI from 'vue-blockui';

import './utils/globalFilters';

import 'bootstrap/dist/css/bootstrap.css';
import '../node_modules/nprogress/nprogress.css';
import '../src/styles/global.css';

Vue.config.productionTip = false;
Vue.use(VueRouter);
const router = new VueRouter({
    mode: 'history',
    routes: [
        {
            name: 'Tool',
            path: '/',
            meta: { requiresAuth: true },
            component: Tool,
        },
        {
            name: 'Login',
            path: '/login',
            meta: { requiresAuth: false },
            component: Login,
        },
    ],
});

router.beforeEach((to, from, next) => {
    const validToken = tokenIsValid();

    if (to.matched.some(record => record.meta.requiresAuth)) {
        if (!validToken) {
            next({ name: 'Login' });
        } else {
            next();
        }
    } else {
        if (to.name === 'Login') {
            if (!validToken) {
                next();
            }
            if (validToken) {
                next({ name: 'Tool' });
            }
        } else {
            next(); // page does not require auth and is not login page
        }
    }
});

Vue.prototype.$moment = moment;
Vue.prototype.$axios = httpClient;
Vue.use(ProgressHub);
Vue.use(BlockUI);

new Vue({
    router,
    render: h => h(App),
}).$mount('#app');
